import { shallowEqual, useSelector } from "react-redux";

import { Card, CardGrid, CardGridArea, CardRowSimple, LoadingSpinner, Tag, TagIntent } from "widgets";

import style from "../core/cards/styles/Card.module.scss";
import styleLayout from "../core/styles/PageLayout.module.scss";

import { type User } from "../../graphql.js";
import { type IAppState } from "../../redux/reducer.js";

export function AccountSettingsOverviewPage() {
  const user = useSelector<IAppState, User>((state) => state.auth.session, shallowEqual);
  const isAuthenticated = useSelector<IAppState, boolean>((state) => state.auth.isAuthenticated, shallowEqual);

  return (
    <CardGrid className={styleLayout.page}>
      <Card key="account-settings-overview-card" title="My account" area={CardGridArea.Left}>
        {!isAuthenticated && <LoadingSpinner inCenter />}
        {isAuthenticated && user && (
          <>
            <CardRowSimple key={"username"} label={"Username"} value={user.username} />
            <CardRowSimple key={"display"} label={"Display name"} value={user.display} />
            <CardRowSimple key={"email"} label={"Email"} value={user.email} />
            <CardRowSimple label={"Roles"}>
              <div className={style.tags_list}>
                {user.roles?.map((role) => (
                  <Tag key={role?.name} intentColor={TagIntent.Secondary}>
                    {role?.name}
                  </Tag>
                ))}
              </div>
            </CardRowSimple>
            <CardRowSimple label={"User groups"}>
              <div className={style.tags_list}>
                {user.userGroups?.map((group) => (
                  <Tag key={group?.name} intentColor={TagIntent.Secondary}>
                    {group?.name}
                  </Tag>
                ))}
              </div>
            </CardRowSimple>
          </>
        )}
      </Card>
    </CardGrid>
  );
}
